export default __webpack_public_path__ + "static/media/karate.0455fe88.jpg";